import * as types from "../actions/types";

const initialState = {
  loading: false
};

export default function directoryExtraEducation(state = initialState, action) {
  switch (action.type) {

    case types.GET_SUBJECTS_EXTRA_EDU_LIST:
      return {
        ...state,
        extraEduList: action.payload
      };
   




    case types.SET_BASIC_EDUCATION_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}